import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/mergeMap';

import { setFilterSelectionBarSetting } from '../../services/software/software-storage';
import { SET_FILTER_SELECTION_BAR_VISIBILITY } from '../../state/actions/filter';
import { rapidViewIdSelector } from '../../state/selectors/software/software-selectors';
import type { MiddlewareAPI, ActionsObservable } from '../../state/types';

export const filterSelectionBarEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$.ofType(SET_FILTER_SELECTION_BAR_VISIBILITY).flatMap((action) => {
		const state = store.getState();
		const isFilterSelectionBarOpen = action.payload.isVisible;

		const rapidViewId = rapidViewIdSelector(state);

		setFilterSelectionBarSetting(Number(rapidViewId), {
			isVisible: isFilterSelectionBarOpen,
		});

		return Observable.empty<never>();
	});
